import { mapState } from 'vuex'

export const mixinIsFilter = {
  data: () => ({
    isFilter: false
  }),
  computed: {
    ...mapState('mobile', {
      isMobile: 'isMobile'
    })
  },
  methods: {
    toggleFilter () {
      console.log(this.isFilter)
      this.isFilter = !this.isFilter
    },
    openFilter () {
      if (this.isMobile) {
        this.openModal('filter')
      } else {
        this.toggleFilter()
      }
    }
  }
}
